// extracted by mini-css-extract-plugin
export var auto = "_4i-1";
export var spinner = "_4i-0";